module.exports = __webpack_public_path__ + "static/media/Skip.28ae2e50.kra";